export const BUYER_ACTIVITY_DATA = [
	{
		name: 'Touhid',
		email: 'touhid@nitex.com',
		mixpanelUrl: 'https://mixpanel.com/p/M5vA1CSAhx7AazBAxsiL9E',
		brands: [
			'Zalando',
			'Simons',
			'Next',
			'BIG STAR LTD',
			'Ndulge',
			'Quiosque',
			's.Oliver',
			'SCALPERS',
			'The Ragged Priest'
		]
	},
	{
		name: 'Jannat',
		email: 'jannat@nitex.com',
		mixpanelUrl: 'https://mixpanel.com/p/SQzhUYC3fpNm5XZcaBbrHe',
		brands: [
			'Zalando',
			'Coppel',
			'Charli',
			'Creations Michele',
			'FRASER GROUP',
			'GOCCO',
			'Mango',
			'Seasalt',
			'Sly Collective',
			'Vinadi',
			'Voice '
		]
	},
	{
		name: 'Andrea',
		email: 'andrea@nitex.com',
		mixpanelUrl: 'https://mixpanel.com/p/DzSArNVmAnzNnRpX4wpqTC',
		brands: ['BERSHKA', 'WITT Weiden', 'OYSHO']
	},
	{
		name: 'Macarena',
		email: 'macarena@nitex.com',
		mixpanelUrl: 'https://mixpanel.com/p/DSRVF67wv7dpFspVk8QaCF',
		brands: ['Coppel', 'Cencosud', 'FALABELLA', 'Smart Brands', "WOMEN'SECRET"]
	},
	{
		name: 'Mahbub',
		email: 'mahbub@nitex.com',
		mixpanelUrl: 'https://mixpanel.com/p/Mrzw6G8tEd4xrbWqjjsh6S',
		brands: ['Next', 'John Lewis Partnership', 'REISS']
	},
	{
		name: 'Mamun',
		email: 'mamun.hossain@nitex.com',
		mixpanelUrl: 'https://mixpanel.com/p/2oxNGy2UURtcs79hmjByvj',
		brands: ['Vance Leather', 'Alife & Kickin']
	},
	{
		name: 'Manjurul',
		email: 'danny@nitex.info',
		mixpanelUrl: 'https://mixpanel.com/p/3ofTaQzXtgE5RFvV6aJ1dh',
		brands: ['REISS', 'CELIO', 'DIESEL', 'FRASER GROUP', 'GAS', 'GIVOVA', 'Very UK']
	},
	{
		name: 'Monika',
		email: 'monika@nitex.com',
		mixpanelUrl: 'https://mixpanel.com/p/KajoUMqJUPraMdzqZy5JLg',
		brands: ['IKKS', 'Pepe jeans', 'RESERVED']
	},
	{
		name: 'Monjur',
		email: 'irteza@nitex.io',
		mixpanelUrl: 'https://mixpanel.com/p/AXQVUwk5EvRmrkgWsJVRGd',
		brands: [
			'LAURA',
			'PROJEK RAW',
			'Salling',
			'Brand BQ',
			'CARRY POLAND',
			'Decathlon',
			'JBC',
			'Medicine',
			'Moss Copenhagen',
			'OFFTEX',
			'ORIENTAL',
			'Roberto Jeans',
			'SINNERUP',
			'Solo Concept',
			'Styli',
			'TEE SHOPPEN'
		]
	},
	{
		name: 'Rezwan',
		email: 'rezwan@nitex.info',
		mixpanelUrl: 'https://mixpanel.com/p/GANnwehKPg5UYvD89ZSJZa',
		brands: ['Tiffosi', 'DUB', 'NOON', 'Vilanova', 'VILET', '', '', '', '']
	},
	{
		name: 'Tanvir',
		email: 'tanvir@nitex.com',
		mixpanelUrl: 'https://mixpanel.com/p/DGyXmz4xSpA4R6WcXgrmUN',
		brands: ['Next']
	},
	{
		name: 'Zia',
		email: 'zia@nitex.info',
		mixpanelUrl: 'https://mixpanel.com/p/Gh8ZUTGtJ87xuhNznjciaz',
		brands: ['29CM', 'GLOWNY', 'Zalando']
	}
];

export const BRAND_ACTIVITY_DATA = [
	{
		name: 'Zalando',
		mixpanelUrl: 'https://mixpanel.com/p/RgptRPxcFJiPRPUzEEP9g8'
	},
	{
		name: 'Next',
		mixpanelUrl: 'https://mixpanel.com/p/4Cg7PWDRM8Y25aCkY6XxvG'
	},
	{
		name: 'Smart Brands',
		mixpanelUrl: 'https://mixpanel.com/p/AZ6v68QGupXShgEotz9RJp'
	},
	{
		name: 'Calliope',
		mixpanelUrl: 'https://mixpanel.com/p/MFtAEBLVambxV3ZHsNrukE'
	},
	{
		name: 'Very UK',
		mixpanelUrl: 'https://mixpanel.com/p/7LnkxSL7WM7tKSX2P6VUeQ'
	},
	{
		name: 'John Lewis Partnership',
		mixpanelUrl: 'https://mixpanel.com/p/LeWMtAJLzEtjQBLmq8jaEz'
	},
	{
		name: "WOMEN'SECRET",
		mixpanelUrl: 'https://mixpanel.com/p/5zRYnTaCkwLineTAZCpcbK'
	},
	{
		name: 'Cencosud',
		mixpanelUrl: 'https://mixpanel.com/p/NpsvgfKfRHub7rGqv4XU8X'
	},
	{
		name: 'Bershka',
		mixpanelUrl: 'https://mixpanel.com/p/NpEhABtDnEGyFHrqiw9Br8'
	},
	{
		name: 'Pepe Jeans',
		mixpanelUrl: 'https://mixpanel.com/p/VCe1rqR47HPKA2dJWYbEhP'
	},
	{
		name: 'Falabella',
		mixpanelUrl: 'https://mixpanel.com/p/GXs1nsFHXGA7NRkU3TGawf'
	},
	{
		name: 'Coppel',
		mixpanelUrl: 'https://mixpanel.com/p/EPN5ocvjnoLi3UZ6gPxnTG'
	},
	{
		name: 'Reserved',
		mixpanelUrl: 'https://mixpanel.com/p/AsC1fQQooQyBiaW9SKoFav'
	},
	{
		name: 'Witt Weiden',
		mixpanelUrl: 'https://mixpanel.com/p/QpiFjfXCDETCiGFjR2m1n5'
	},
	{
		name: 'Oysho',
		mixpanelUrl: 'https://mixpanel.com/p/UBEV8wWapurQXVUg41xuJB'
	},
	{
		name: 'Celio',
		mixpanelUrl: 'https://mixpanel.com/p/4pCSqmH4CYZq9KUcVnZcfY'
	},
	{
		name: 'Vilanova',
		mixpanelUrl: 'https://mixpanel.com/p/TdPu37sxg1PnJTT9PDHaBC'
	},
	{
		name: 'Gas',
		mixpanelUrl: 'https://mixpanel.com/p/TdPu37sxg1PnJTT9PDHaBC'
	},
	{
		name: 'Givova',
		mixpanelUrl: 'https://mixpanel.com/p/BX8E9VecpYFrx3XPQ3ecbK'
	},
	{
		name: 'Diesel',
		mixpanelUrl: 'https://mixpanel.com/p/FhNbSmUUu8YGaBKTNJsXQQ'
	},
	{
		name: 'Reiss',
		mixpanelUrl: 'https://mixpanel.com/p/3Zg65qAPDvUgdhkgQCmHzw'
	},
	{
		name: 'Fraser Group',
		mixpanelUrl: 'https://mixpanel.com/p/SUkazT9XQ9U28Z2Vmturk3'
	},
	{
		name: 'Seasalt',
		mixpanelUrl: 'https://mixpanel.com/p/3XJkbPukUbA7nCYetDiwtw'
	},
	{
		name: 'Noon Spain SL',
		mixpanelUrl: 'https://mixpanel.com/p/UDy6ou4FBsCfQzar3LZVrW'
	},
	{
		name: 'Vilet',
		mixpanelUrl: 'https://mixpanel.com/p/6xT9Q6wXbuU1nSEAXNp2gV'
	},
	{
		name: 'Tiffosi',
		mixpanelUrl: 'https://mixpanel.com/p/EEG3uk6YbckN6aoCRgkqRv'
	},
	{
		name: 'DUB',
		mixpanelUrl: 'https://mixpanel.com/p/BhMidKM6TsaBdy7k5HpEF8'
	},
	{
		name: 'Freemans Grattan',
		mixpanelUrl: 'https://mixpanel.com/p/MgbhyqHUnFd7zaKm4YE7d9'
	},
	{
		name: 'Salling',
		mixpanelUrl: 'https://mixpanel.com/p/DsmSaLM4GvzCswEMvG8m4G'
	},
	{
		name: 'Merchandise‑Supply',
		mixpanelUrl: 'https://mixpanel.com/p/YTQvrJvuxjBtcwoac1R7Hp'
	},
	{
		name: 'Parfois',
		mixpanelUrl: 'https://mixpanel.com/p/J3A3UK26gSQGTtsXasW4VR'
	},
	{
		name: 'Salsa',
		mixpanelUrl: 'https://mixpanel.com/p/Trh9EkoRrabP4SAHyMkwKp'
	},
	{
		name: 'Scalpers',
		mixpanelUrl: 'https://mixpanel.com/p/RUnzNvZuwUiXbDdodq3WXb'
	},
	{
		name: 'Smiley',
		mixpanelUrl: 'https://mixpanel.com/p/VoKjtjCwrqsyW6z3dztGQN'
	},
	{
		name: 'Zara',
		mixpanelUrl: 'https://mixpanel.com/p/Kdvv9RxANG9ZkPyozD68W7'
	},
	{
		name: 'Alife & Kickin',
		mixpanelUrl: 'https://mixpanel.com/p/XZsmuxGSKUGLCVUX6C6RFG'
	},
	{
		name: 'Simons',
		mixpanelUrl: 'https://mixpanel.com/p/WeJRXKJRVrd4UMaY8bJ7XF'
	},
	{
		name: 'Mango',
		mixpanelUrl: 'https://mixpanel.com/p/MPwDnD8kSrCSQEkxGNqgxd'
	},
	{
		name: "Sainsbury's",
		mixpanelUrl: 'https://mixpanel.com/p/9fuo8TEmoKbSDb5WYmn9TS'
	},
	{
		name: 'Thinking Mu',
		mixpanelUrl: 'https://mixpanel.com/p/UVez3g8UR8BLsEPJj1NW38'
	},
	{
		name: 'Amazon',
		mixpanelUrl: 'https://mixpanel.com/p/EyBkMJbhwg6mCQMEr6AMRX'
	},
	{
		name: 'River Island',
		mixpanelUrl: 'https://mixpanel.com/p/DTbXKUXZnmqZvD3qNEeRd8'
	},
	{
		name: 'Styli',
		mixpanelUrl: 'https://mixpanel.com/p/LJwyJpC6B8dBw8LbV6gAXn'
	},
	{
		name: 'TEE Shoppen',
		mixpanelUrl: 'https://mixpanel.com/p/35c42Y1sBRj3MDhKS1jKUf'
	},
	{
		name: 'Babidu',
		mixpanelUrl: 'https://mixpanel.com/p/RkEJWmdk4ipFmXESsmrDnZ'
	},
	{
		name: 'Sinnerup',
		mixpanelUrl: 'https://mixpanel.com/p/9hZRrmUdvktVb16cuLvMuA'
	},
	{
		name: 'Glowny',
		mixpanelUrl: 'https://mixpanel.com/p/WMXuP9TZiHquAKq5CWLrVD'
	},
	{
		name: '29CM',
		mixpanelUrl: 'https://mixpanel.com/p/FWFFhikBcjbm79wTrpHgzU'
	},
	{
		name: 'Fruit of the Loom',
		mixpanelUrl: 'https://mixpanel.com/p/JiK5uE94QcMebWSMaF3AXd'
	},
	{
		name: 'Vance Leather',
		mixpanelUrl: 'https://mixpanel.com/p/7Vd2hofND7z5vnqkkK56cf'
	},
	{
		name: 'New Look',
		mixpanelUrl: 'https://mixpanel.com/p/QeVmV9Ds4un7X17mRKsZKW'
	},
	{
		name: 'Carry Poland / Carry',
		mixpanelUrl: 'https://mixpanel.com/p/Rcy79PTCZtoGnrWL7arxBY'
	},
	{
		name: 'Absolute Apparels',
		mixpanelUrl: 'https://mixpanel.com/p/3cvNUL4jTgNpGMk9vzUHgu'
	},
	{
		name: 'Primark',
		mixpanelUrl: 'https://mixpanel.com/p/PUWycaociE5Pz3Qxn5MKmg'
	},
	{
		name: 'Topshop',
		mixpanelUrl: 'https://mixpanel.com/p/TyDmvwARASmQBpjVZ7CbeW'
	},
	{
		name: 'Lefties',
		mixpanelUrl: 'https://mixpanel.com/p/2NiKdrEnUNFh9QgVYpnNey'
	},
	{
		name: 'Familia',
		mixpanelUrl: 'https://mixpanel.com/p/UzMw3ZknAAPfuSkWt8DvVk'
	},
	{
		name: 'Laura',
		mixpanelUrl: 'https://mixpanel.com/p/ADQU2d5QHZnTkbCXerYPS3'
	},
	{
		name: 'Big Star Ltd',
		mixpanelUrl: 'https://mixpanel.com/p/XohJh7YHRoVr4yGotrbzu5'
	},
	{
		name: 'Debenhams',
		mixpanelUrl: 'https://mixpanel.com/p/6MKZm1dVKHmMxS5TjiVM31'
	},
	{
		name: 'Lipsy',
		mixpanelUrl: 'https://mixpanel.com/p/DFoC4vyLiGRUG2dehWV1H5'
	},
	{
		name: 'Gocco',
		mixpanelUrl: 'https://mixpanel.com/p/5gY9iEgqWY5hrmPbtQr1Ad'
	},
	{
		name: 'Topitop',
		mixpanelUrl: 'https://mixpanel.com/p/2SoSrKCdap3MpYKKYsgNrr'
	},
	{
		name: 'Project111',
		mixpanelUrl: 'https://mixpanel.com/p/THkTCHqMFEeggNkXi4HWsW'
	},
	{
		name: 'E Plus M',
		mixpanelUrl: 'https://mixpanel.com/p/TmtwUVQYvtBeDytpdxpEZk'
	},
	{
		name: 'Nitex',
		mixpanelUrl: 'https://mixpanel.com/p/TMgtLuBPBvt7PtQcN9dAYU'
	},
	{
		name: 'Tesco',
		mixpanelUrl: 'https://mixpanel.com/p/YKybjq2ebs4G6M5MfsrazX'
	},
	{
		name: 'Ardene',
		mixpanelUrl: 'https://mixpanel.com/p/S3HsTkSwZZvmxzs5wUPUcF'
	},
	{
		name: 'Urban Outfitters',
		mixpanelUrl: 'https://mixpanel.com/p/SCjgKHXiBCB7wbywJg49v5'
	},
	{
		name: 'TK Maxx',
		mixpanelUrl: 'https://mixpanel.com/p/6Xq1MbUB1DApUQFGvrHxJb'
	},
	{
		name: 'State of Flux Shop',
		mixpanelUrl: 'https://mixpanel.com/p/6Ysmw5sAMfqNBmj1kuT6sV'
	},
	{
		name: 'Envelope',
		mixpanelUrl: 'https://mixpanel.com/p/LsMdpMkZfFCrR1pAUNZY4N'
	},
	{
		name: 'JBC',
		mixpanelUrl: 'https://mixpanel.com/p/CPHTSiMrndF4fcLkNdAv3n'
	},
	{
		name: 'Sela',
		mixpanelUrl: 'https://mixpanel.com/p/K4hLwBJ4TQ2GpWbqRCtHcu'
	},
	{
		name: 'Honest Basics',
		mixpanelUrl: 'https://mixpanel.com/p/PN3xWuuheMkXvetF6NUaLL'
	},
	{
		name: 'BestSeller',
		mixpanelUrl: 'https://mixpanel.com/p/EQXjAQ3N84JENhQjkraJAD'
	},
	{
		name: 'Cala',
		mixpanelUrl: 'https://mixpanel.com/p/AnBBJsKZMZPdaBjzXviVmV'
	},
	{
		name: 'Liberte Essentiel',
		mixpanelUrl: 'https://mixpanel.com/p/8N9hzHARivpjVUFDvHayXV'
	},
	{
		name: 'Cotton On',
		mixpanelUrl: 'https://mixpanel.com/p/TNb3eC6WfnvaCSFhKsniuE'
	},
	{
		name: 'Topman',
		mixpanelUrl: 'https://mixpanel.com/p/XyerSVq7frF4Cnit1vtjMH'
	},
	{
		name: 'Oriental',
		mixpanelUrl: 'https://mixpanel.com/p/T1ZybnppiGymDLVZFiTpvi'
	},
	{
		name: 'Hoxleigh',
		mixpanelUrl: 'https://mixpanel.com/p/WBqgvhMCkPJBFjE9k4uk61'
	},
	{
		name: 'MBO',
		mixpanelUrl: 'https://mixpanel.com/p/U8jumqvofqNo8NBambRinV'
	},
	{
		name: 'Celebrity Dance',
		mixpanelUrl: 'https://mixpanel.com/p/GHiSfJzSY9tXj9c6ANqAvn'
	},
	{
		name: 'Quiosque',
		mixpanelUrl: 'https://mixpanel.com/p/8ype51srFt7k3MwCvrGYuJ'
	},
	{
		name: 'Creations Michele',
		mixpanelUrl: 'https://mixpanel.com/p/ErjfBRtAN5PhGkeLmfCS89'
	},
	{
		name: 'Zippy Losan',
		mixpanelUrl: 'https://mixpanel.com/p/K5gvhQsqbtXuaqhDTbLa6j'
	},
	{
		name: 'Universal Store',
		mixpanelUrl: 'https://mixpanel.com/p/4pw5i8NJWFbQcLJovEtEYF'
	},
	{
		name: 'Moss Bros',
		mixpanelUrl: 'https://mixpanel.com/p/7JPRkwqiV5myqvHYP5bTdT'
	},
	{
		name: 'Voice',
		mixpanelUrl: 'https://mixpanel.com/p/Ay2PMHgGuD9hvcxHDyJhu3'
	},
	{
		name: 'Enragé',
		mixpanelUrl: 'https://mixpanel.com/p/5vuUfoTdCoPQJeQAbZGtWU'
	},
	{
		name: 'Offtex',
		mixpanelUrl: 'https://mixpanel.com/p/WoGv38HNj36T8vfUGZvUqY'
	},
	{
		name: 'Concept Group',
		mixpanelUrl: 'https://mixpanel.com/p/Wzu84tS54NXfCPwyiVPC6c'
	},
	{
		name: 'The Levy Group',
		mixpanelUrl: 'https://mixpanel.com/p/9SBQVyn32MPVxNi4YSXda8'
	},
	{
		name: 'Roberto Jeans',
		mixpanelUrl: 'https://mixpanel.com/p/HcJg3fwPep5qPkBLuLFi2h'
	},
	{
		name: 'Sonae Sports & Fashion',
		mixpanelUrl: 'https://mixpanel.com/p/WB1RKmmcr76vuCiH83K6vJ'
	},
	{
		name: 'Patience Mad',
		mixpanelUrl: 'https://mixpanel.com/p/CpRbw2jPEJqTMiiRpNLw6N'
	},
	{
		name: 'Linen Club',
		mixpanelUrl: 'https://mixpanel.com/p/Hr8DUauArzMbM1uYZxGi1y'
	},
	{
		name: 'Spykar',
		mixpanelUrl: 'https://mixpanel.com/p/P7qq98AV4Pj25CZqhWoJ6X'
	},
	{
		name: 'Stradivarius',
		mixpanelUrl: 'https://mixpanel.com/p/4qsv9JcBRq8zZAN63W7nSH'
	},
	{
		name: 'Adore Me',
		mixpanelUrl: 'https://mixpanel.com/p/QHKasxTkrESJTsnfFJD9Ew'
	},
	{
		name: 'Defacto',
		mixpanelUrl: 'https://mixpanel.com/p/XtxDEqMp1a6B7Paw82GCJG'
	},
	{
		name: 'Decathlon',
		mixpanelUrl: 'https://mixpanel.com/p/Nkw73Rfdf5mfh5gXCtSEeB'
	},
	{
		name: 'NuvoMode',
		mixpanelUrl: 'https://mixpanel.com/p/NHFA2yuLoFFJdKuWnvcvLs'
	},
	{
		name: 'Sly Collective',
		mixpanelUrl: 'https://mixpanel.com/p/BKCmZ9XHNWtArYvR3fKzNN'
	},
	{
		name: 'Brand BQ',
		mixpanelUrl: 'https://mixpanel.com/p/7iKxNNnnCbhydSu9vfu4j2'
	},
	{
		name: 'Ndulg',
		mixpanelUrl: 'https://mixpanel.com/p/F9repLY8HC185gbbyXu8gA'
	},
	{
		name: 'The Ragged Priest',
		mixpanelUrl: 'https://mixpanel.com/p/1MZRNmwu8q884qiuxMDAU4'
	},
	{
		name: 'Solo Concept',
		mixpanelUrl: 'https://mixpanel.com/p/TGkGBHztJcLoJi3gazspdq'
	},
	{
		name: 'Charli',
		mixpanelUrl: 'https://mixpanel.com/p/Mm9t5FVrYKh4GzqdbFvLfw'
	},
	{
		name: 'Dare Rare',
		mixpanelUrl: 'https://mixpanel.com/p/JtBHfkFAdSvzqfPwCM2dKN'
	},
	{
		name: 'Sport Promotion Service',
		mixpanelUrl: 'https://mixpanel.com/p/RLmku3LnDVZ18GmHoH7p9h'
	},
	{
		name: 'ST Protect Spa',
		mixpanelUrl: 'https://mixpanel.com/p/CTABKEFoGLUrovi5KyuoWU'
	},
	{
		name: 'TSM',
		mixpanelUrl: 'https://mixpanel.com/p/FEiz5ALyfEjTG3G2gA3YT3'
	},
	{
		name: 'TXM',
		mixpanelUrl: 'https://mixpanel.com/p/WriDwKPQaUiYLDFhuiv1oz'
	},
	{
		name: 'Bsb Fashion',
		mixpanelUrl: 'https://mixpanel.com/p/C5oiNajjf5LR5n2exW1ETt'
	},
	{
		name: 'Jammers',
		mixpanelUrl: 'https://mixpanel.com/p/LKqoawQTH9h2SJEUGR7Piz'
	},
	{
		name: 'Medicine',
		mixpanelUrl: 'https://mixpanel.com/p/FfrDDRxjEy9gkdfhRLH263'
	},
	{
		name: 'EWM',
		mixpanelUrl: 'https://mixpanel.com/p/GpkmVy3kXSLxrghDqLkiiM'
	},
	{
		name: 'Melon Fashion Group',
		mixpanelUrl: 'https://mixpanel.com/p/EiMnHAt71bu6qnyk12if2v'
	}
];
